import getClient from 'utilities/startplusGraphql';
import { Queries } from 'apollo';

const useGetOfferFile = async ({ offerId, isPreview }) => {
  const startPlusClient = await getClient();
  const response = await startPlusClient.query({
    query: Queries.GetMyOfferFile,
    variables: { offerId },
    fetchPolicy: 'no-cache',
  });
  const { completedOffers } = response.data;
  const url = completedOffers[0].url;
  if (isPreview) {
    // Return viewer 'file'
    return { url, withCredentials: false };
  }
  // Return downloader url
  return url;
};

export default useGetOfferFile;
